import { getAmbientTrace, Outcomes, Tags } from "@sgi/af-shell-shared";

import("./AppBootstrap")
  .then(async ({ renderApp }) => {
    await renderApp();
  })
  .catch(error => {
    getAmbientTrace()?.trackException(error, {
      [Tags.AppComponent]: "remote-entry",
      [Tags.AppOperation]: "render-app",
      [Tags.AppOutcome]: Outcomes.Failure,
    });
    // eslint-disable-next-line no-console
    console.error("Failed to render the application:", error);
  });

export {};
